import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const FAQ = () => {
  return (
  <section className="py-20 bg-gray-50">
    <div className="container px-4 md:px-6">
      <div className="text-center mb-16">
        <h2 className="text-3xl font-bold mb-4">Frequently Asked Questions</h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Everything you need to know about joining our therapist network.
        </p>
      </div>

      <div className="max-w-4xl mx-auto space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>What qualifications do I need to join?</CardTitle>
          </CardHeader>
          <CardContent>
            <p>You must be a licensed mental health professional in your state or country of practice. This includes psychologists, psychiatrists, licensed counselors, social workers, and marriage and family therapists.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>How do I get matched with clients?</CardTitle>
          </CardHeader>
          <CardContent>
            <p>Clients complete a comprehensive assessment that helps match them with therapists based on their specific needs, cultural background, and preferences. You'll receive notifications when a potential match is found.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>What support do you offer for therapists?</CardTitle>
          </CardHeader>
          <CardContent>
            <p>We provide ongoing technical support, marketing resources, continuing education opportunities, and a community of peers focused on cultural competence in therapy practice.</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>How are payments handled?</CardTitle>
          </CardHeader>
          <CardContent>
            <p>We process client payments through our secure platform and deposit funds directly to your bank account. We handle all payment processing, insurance verifications, and billing to make your practice management easier.</p>
          </CardContent>
        </Card>
      </div>
    </div>
  </section>
  )
}

export default FAQ;